import axios from 'axios';

export const externalapi = axios.create({
  baseURL: "/external-hub/", // neutered: was prod hub.brainymed.com
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});
